import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

interface Props {
  onFileUpload: (file: File) => void;
}

export const InputFileUploadCSV: React.FC<Props> = ({ onFileUpload }) => {
  
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    // Verificar si hay archivos seleccionados
    if (files && files.length > 0) {
      const file = files[0]; // Obtener el primer archivo

      // Verificar que sea un archivo CSV
      if (file.type === 'text/csv') {
        onFileUpload(file);
      } else {
        console.error('Por favor, selecciona un archivo CSV.');
      }
    }
  };

  return (
    <Button
      component="label"
      variant="contained"
      sx={{ marginLeft: 2, height: '100%', backgroundColor: '#2B7C83' }}
      startIcon={<CloudUploadIcon />}
    >
      Upload
      <VisuallyHiddenInput
        type="file"
        onChange={handleFileChange}
        accept="text/csv"
      />
    </Button>
  );
}
